import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class LoginFooterNavigation extends Component {
    render() {
        return (
            <div className="footer-links text-center">
                <Link to="/">Logga in</Link>
                <Link to="/hjalp">Hjälp</Link>
                <Link to="/admin">Administratör</Link>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/partials/LoginFooterNavigation.js